// Date / timezone helpers for VERSE CRM (display only; server stores UTC).
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isoWeek from 'dayjs/plugin/isoWeek';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);
dayjs.extend(advancedFormat);

export const MYT = 'Asia/Kuala_Lumpur';

export const toMytDate = (v) => (v ? dayjs.utc(v).tz(MYT).format('YYYY-MM-DD') : '');
export const toMytDateTime = (v) => (v ? dayjs.utc(v).tz(MYT).format('YYYY-MM-DD HH:mm') : '');
export const toMytRelative = (v) => {
  if (!v) return '';
  const d = dayjs.utc(v).tz(MYT);
  const now = dayjs().tz(MYT);
  const diffMin = now.diff(d, 'minute');
  if (diffMin < 1) return 'just now';
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffHr = now.diff(d, 'hour');
  if (diffHr < 24) return `${diffHr}h ago`;
  const diffDay = now.diff(d, 'day');
  if (diffDay < 7) return `${diffDay}d ago`;
  return d.format('D MMM');
};

export const todayMyt = () => dayjs().tz(MYT).format('YYYY-MM-DD');

// Clinic weeks run Sunday → Saturday (MYT). W1 = the week containing 1 Jan.
export const sunWeek = (v) => {
  const d = (v ? dayjs.utc(v) : dayjs()).tz(MYT).startOf('day');
  const start = d.subtract(d.day(), 'day');
  const end = start.add(6, 'day');
  const jan1 = end.startOf('year');  // number by the week's Saturday so the week holding 1 Jan is W1 for all its days
  const wk = Math.floor((end.diff(jan1, 'day') + jan1.day()) / 7) + 1;
  return { key: start.format('YYYY-MM-DD'), wk, label: `W${wk}`, start: start.format('YYYY-MM-DD'), end: end.format('YYYY-MM-DD'),
    range: start.month() === end.month() ? `${start.format('D')}–${end.format('D MMM')}` : `${start.format('D MMM')} – ${end.format('D MMM')}` };
};
export const fmtCameIn = (v) => (v ? dayjs.utc(v).tz(MYT).format('D MMM YYYY, h:mma') : '');

export const isoWeekFor = (dateStr) => {
  const d = dateStr ? dayjs(dateStr).tz(MYT) : dayjs().tz(MYT);
  const monday = d.isoWeekday(1);
  const sunday = d.isoWeekday(7);
  return {
    label: `${d.isoWeekYear()}-W${String(d.isoWeek()).padStart(2, '0')}`,
    monday: monday.format('YYYY-MM-DD'),
    sunday: sunday.format('YYYY-MM-DD'),
    rangeLabel: `${monday.format('D MMM')} – ${sunday.format('D MMM')}`,
  };
};

export const addDaysMyt = (dateStr, days) =>
  dayjs.tz(dateStr || todayMyt(), MYT).add(days, 'day').format('YYYY-MM-DD');
